import { analyticsFormatType } from "./AnalyticsUtils";
import { MechanicalItemReportAnalyticsProps } from "../interfaces/mechanicalReportAnalytics";

export const MechanicalItemReportAnalytics = ({
  reportType,
  categoryMapping,
}: MechanicalItemReportAnalyticsProps) => {
  let countOfRed = 0;
  let countOfAmber = 0;

  if (reportType === "NoReport") {
    return "none|none";
  }

  if (reportType === "FullInspection") {
    return "128|none";
  }

  if (categoryMapping?.length > 0) {
    categoryMapping.forEach((category) => {
      countOfAmber += category.numberOfAmber;
      countOfRed += category.numberOfRed;
    });

    if (countOfAmber && countOfRed) {
      return analyticsFormatType[reportType] + "|red-amber";
    } else if (countOfAmber) {
      return analyticsFormatType[reportType] + "|amber";
    } else if (countOfRed) {
      return analyticsFormatType[reportType] + "|red";
    }

    return analyticsFormatType[reportType] + "|green";
  }

  return "none|none";
};
